export const checkCLMediaNameFormat = (mediaName: string) => {
  return (
    mediaName.endsWith("_DEMO") ||
    mediaName.endsWith("_DIP") ||
    mediaName.endsWith("_SNS") ||
    mediaName.endsWith("_PA") ||
    mediaName.endsWith("_DB")
  );
};
